import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "alert-setting" }
const _hoisted_2 = { class: "text-2xl font-bold" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "font-bold text-lg mb-1" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_6 = { class: "box-setting mb-8" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "w-2/5" }
const _hoisted_10 = { class: "box-setting mb-8" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = { class: "w-2/5" }
const _hoisted_14 = { class: "box-setting mb-8" }
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = { class: "w-2/5" }
const _hoisted_18 = { class: "box-setting mb-8" }
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = { class: "w-2/5" }
const _hoisted_22 = { class: "box-setting mb-8" }
const _hoisted_23 = { class: "mb-4" }
const _hoisted_24 = { class: "flex items-center" }
const _hoisted_25 = { class: "w-2/5" }
const _hoisted_26 = { class: "mb-8" }
const _hoisted_27 = { class: "font-bold text-lg mb-1" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_29 = { class: "box-setting mb-8" }
const _hoisted_30 = { class: "mb-4" }
const _hoisted_31 = { class: "flex items-center" }
const _hoisted_32 = { class: "w-2/5" }
const _hoisted_33 = { class: "box-setting mb-8" }
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = { class: "flex items-center" }
const _hoisted_36 = { class: "w-2/5" }
const _hoisted_37 = { class: "box-setting mb-8" }
const _hoisted_38 = { class: "mb-4" }
const _hoisted_39 = { class: "flex items-center" }
const _hoisted_40 = { class: "w-2/5" }
const _hoisted_41 = { class: "flex items-center mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioGroup = _resolveComponent("RadioGroup")
  const _component_PlusIcon = _resolveComponent("PlusIcon")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('errorAlertSettings')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t('alertSetting.timeAttendanceData')), 1),
      _hoisted_5
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('alertSetting.workSchedule')), 1),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_RadioGroup, {
            "options-radio": _ctx.workScheduleOption,
            modelValue: _ctx.apiPostAlertData.work_schedule_not_stamps,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.apiPostAlertData.work_schedule_not_stamps = $event))
          }, null, 8, ["options-radio", "modelValue"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, _toDisplayString(_ctx.t('alertSetting.noHolidayCommuting')), 1),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_RadioGroup, {
            "options-radio": _ctx.workScheduleOption,
            modelValue: _ctx.apiPostAlertData.work_holiday_not_application,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.apiPostAlertData.work_holiday_not_application = $event))
          }, null, 8, ["options-radio", "modelValue"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("div", _hoisted_15, _toDisplayString(_ctx.t('alertSetting.noOvertimeApplication')), 1),
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_RadioGroup, {
            "options-radio": _ctx.workScheduleOption,
            modelValue: _ctx.apiPostAlertData.not_over_time_application,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.apiPostAlertData.not_over_time_application = $event))
          }, null, 8, ["options-radio", "modelValue"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_18, [
      _createVNode("div", _hoisted_19, _toDisplayString(_ctx.t('alertSetting.duplicateAttendanceData')), 1),
      _createVNode("div", _hoisted_20, [
        _createVNode("div", _hoisted_21, [
          _createVNode(_component_RadioGroup, {
            "options-radio": _ctx.workScheduleOption,
            modelValue: _ctx.apiPostAlertData.duplicate_attendance_data,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.apiPostAlertData.duplicate_attendance_data = $event))
          }, null, 8, ["options-radio", "modelValue"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_22, [
      _createVNode("div", _hoisted_23, _toDisplayString(_ctx.t('alertSetting.duplicateStamps')), 1),
      _createVNode("div", _hoisted_24, [
        _createVNode("div", _hoisted_25, [
          _createVNode(_component_RadioGroup, {
            "options-radio": _ctx.workScheduleOption,
            modelValue: _ctx.apiPostAlertData.duplicate_stamps,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.apiPostAlertData.duplicate_stamps = $event))
          }, null, 8, ["options-radio", "modelValue"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_26, [
      _createVNode("div", _hoisted_27, _toDisplayString(_ctx.t('alertSetting.workStyleAlert')), 1),
      _hoisted_28
    ]),
    _createVNode("div", _hoisted_29, [
      _createVNode("div", _hoisted_30, _toDisplayString(_ctx.t('alertSetting.upperLimitOvertimeWork')), 1),
      _createVNode("div", _hoisted_31, [
        _createVNode("div", _hoisted_32, [
          _createVNode(_component_RadioGroup, {
            "options-radio": _ctx.workStyleAlertOption,
            modelValue: _ctx.apiPostAlertData.upper_limit_over_time,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.apiPostAlertData.upper_limit_over_time = $event))
          }, null, 8, ["options-radio", "modelValue"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_33, [
      _createVNode("div", _hoisted_34, _toDisplayString(_ctx.t('alertSetting.upperLimitOvertimeHolidayWork')), 1),
      _createVNode("div", _hoisted_35, [
        _createVNode("div", _hoisted_36, [
          _createVNode(_component_RadioGroup, {
            "options-radio": _ctx.workStyleAlertOption,
            modelValue: _ctx.apiPostAlertData.upper_limit_over_time_and_holiday_work,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.apiPostAlertData.upper_limit_over_time_and_holiday_work = $event))
          }, null, 8, ["options-radio", "modelValue"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_37, [
      _createVNode("div", _hoisted_38, _toDisplayString(_ctx.t('alertSetting.upperLimitOvertimeWorkProvisions')), 1),
      _createVNode("div", _hoisted_39, [
        _createVNode("div", _hoisted_40, [
          _createVNode(_component_RadioGroup, {
            "options-radio": _ctx.workStyleAlertOption,
            modelValue: 
              _ctx.apiPostAlertData.upper_limit_over_time_work_special_provisions
            ,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (
              _ctx.apiPostAlertData.upper_limit_over_time_work_special_provisions
             = $event))
          }, null, 8, ["options-radio", "modelValue"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_41, [
      _createVNode(_component_Button, {
        class: "mr-4",
        onClick: _ctx.handleNavigationAlertSetting
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PlusIcon, { class: "mr-1 items-center" }),
          _createTextVNode(_toDisplayString(_ctx.t('approvedFlow.toRegister')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}